// import Vue from "vue"
// console.log(Vue)
// console.log(Vue.axios)
// let axios = Vue.axios

// this.radio = res.data.data?'0':'1'
// 是否隐藏  true 需要隐藏电话号码中间四位false 无需隐藏
let isHiddenPhone = (vue) => {
  //api/platform/getCorpIsConcealPhone  =>/service-user-app/app/corp-config/corp-conceal-phone 待联调
  return vue.axios({
    method: "get",
    url: "/service-user-app/app/corp-config/corp-conceal-phone",
  });
};

let forSpace = (vue) => {
  return Promise.resolve({
    data: {},
  });
};
// 注释三个无用接口
let forBill = (vue) => {
  return Promise.resolve({
    data: {},
  });
  // return vue.axios({
  //   method: 'get',
  //   url: '/service-invoice-app/app/get-shop-bill-recognition-usage',
  //   interface: 1
  // })
};

let forTax = (vue) => {
  return Promise.resolve({
    data: {},
  });
  // return vue.axios({
  //   method: 'get',
  //   url: '/service-invoice-app/app/online-invoice/get-tax-disk-usage',
  //   interface: 1
  // })
};
let forBook = (vue) => {
  return Promise.resolve({
    data: {},
  });
  // return vue.axios({
  //   method: 'get',
  //   url: '/service-account-book-app/app/account-book/corp-account-book-num',
  //   interface: 1
  // })
};
let forText = (vue) => {
  // let info = JSON.parse(window.LS.get("SY") || '{}')
  return vue.axios({
    method: "get",
    url: "/service-sms-app/app/corp-balance/record-corp-pk",
    params: {
      // 删除corp对象,直接获取corpid 待联调
      // corpPk: info && info.corp && info.corp.pkCorp
      corpId: JSON.parse(localStorage.getItem("corpId")),
    },
    interface: 1,
  });
};
let forCustomer = (vue) => {
  return vue.axios({
    method: "get",
    url: "/service-customer-app/app/customer/merchant-customer-count",
    interface: 1,
  });
};

let forMeal = (vue) => {
  return vue.axios({
    method: "get",
    url: "/service-call-app/app/statistics/seat-meal",
    interface: 1,
  });
};

let getHDept = (vue) => {
  return vue.axios({
    method: "get",
    url: "/platform/loadDepts",
    interface: 1,
  });
};

let forUser = (vue) => {
  return Promise.resolve({
    data: {},
  });
};

let forMall = (vue) => {
  return vue.axios({
    method: "get",
    url: "/service-personal-mall-app/app/personal-mall/store-statistics",
    interface: 1,
  });
};

export {
  isHiddenPhone,
  forSpace,
  forCustomer,
  forMeal,
  forText,
  getHDept,
  forUser,
  forMall,
  forBill,
  forBook,
  forTax,
};
